export { ContentSnippetsSortType } from './dto';
export * from './dto';
var contentSnippetsRelativePath = '/contentsnippets';
export var createContentSnippetsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + contentSnippetsRelativePath;
    return {
        get: function (getContentSnippetDto) {
            return http.get("".concat(apiUrl, "/").concat(getContentSnippetDto.id, "/?locale=").concat(getContentSnippetDto.locale), getContentSnippetDto);
        },
        getAll: function (getAllContentSnippetsDto) {
            return http.get("".concat(apiUrl, "/?locale=").concat(getAllContentSnippetsDto.locale), getAllContentSnippetsDto);
        },
        add: function (addContentSnippetDTO) {
            return http.post("".concat(apiUrl, "/"), addContentSnippetDTO);
        },
        update: function (updateContentSnippetDTO) {
            return http.put("".concat(apiUrl, "/").concat(updateContentSnippetDTO.id, "/"), updateContentSnippetDTO);
        },
        delete: function (deleteContentSnippetDTO) {
            return http.delete("".concat(apiUrl, "/").concat(deleteContentSnippetDTO.id, "/?locale=").concat(deleteContentSnippetDTO.locale), deleteContentSnippetDTO);
        },
        search: function (searchContentSnippetsDTO) {
            return http.post("".concat(apiUrl, "/search"), searchContentSnippetsDTO);
        },
    };
};
//# sourceMappingURL=index.js.map